import Settings from './SettingsActions'
import settings from '../virtuoso/settings';
import {namespaces} from '../semantic/settings';

/** Описание элементов для значений по умолчанию
 * Определяет текущий граф, текущий язык и доступные языки, пространства имён
*/

const initialVSetState = {
    graph: null,
    lang: settings.defaultLocale,
    isSignedIn: true,
    languages: ["ru", "en"],
    xmlns:namespaces,
}

export const vset = (state = { ...initialVSetState} , action) => {
    switch (action.type) {
        case Settings.GRAPH: 
            return{
                ...state,
                graph: action.graph
            }
        case Settings.LANG: 
            return{
                ...state,
                lang: action.lang
            }
        case Settings.SIGNED: 
            return{
                ...state,
                isSignedIn: action.isSignedIn
            }
        default:
            return state;
    }
}

